import { TreeNode } from '../models/TreeNode';
import { ItemTreeDto } from '../../../../../../api-main';
import ItemTypeCodeEnum = ItemTreeDto.ItemTypeCodeEnum;

export function getNodeUrl(item: TreeNode): string {
  const type: ItemTypeCodeEnum = item.item_type_code as ItemTypeCodeEnum;

  if (item.pointingUrl) return item.pointingUrl;

  switch (type) {
    case ItemTypeCodeEnum.IOT:
    case ItemTypeCodeEnum.LORA:
    case ItemTypeCodeEnum.LOGGER:
      return `device/${item.item_id ?? 0}`;
    case ItemTypeCodeEnum.DASHBOARD:
      return `/dashboards/${item.item_id}`;
    case ItemTypeCodeEnum.VDEVICE: // When parent is M-Center
      return `meter/${item.parent_id ?? 0}/${item.item_id ?? 0}`;
    case ItemTypeCodeEnum.DEVICE:  // When meter is placed on tree
      return `meter/${item.id}`;
    case ItemTypeCodeEnum.FILE:
    case ItemTypeCodeEnum.FOLDER:
    default:
      return `/tree/inspect/${item.id}`;
  }
}
